import Switch from "@mui/material/Switch";
import BackButton from "components/BackButton";
import Loader from "components/common/Loader";
import ContactInput from "components/ContactInput";
import IslandLayout from "components/IslandLayout";
import LineBreak from "components/LineBreak";
import PageLayout from "components/PageLayout";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  emailAdminInvite,
  emailMemberInvite,
  getChannelList,
  phoneAdminInvite,
  phoneMemberInvite,
} from "store/async-actions/Hive/hivePage";
import { getActiveChannelUuidSelector } from "store/reducers/ChannelDetails/channelList";
import { getHiveSelector } from "store/reducers/HiveDetails/hiveDetails";
import {
  getPhoneUsersSelector,
  hiveMembersLoadingSelector,
  inviteSentSelector,
  inviteToChannelsList,
  setInvitedMember,
  setSingleInviteToChannel,
} from "store/reducers/HiveDetails/hiveSettings";
import { isMemberViewSelector } from "store/reducers/Profile/profile";

const ChannelInvite = () => {
  const inviteToChannels = useAppSelector(inviteToChannelsList);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const channelUuid = useAppSelector(getActiveChannelUuidSelector);

  const hiveDetails = useAppSelector(getHiveSelector);

  const isLoading = useAppSelector(hiveMembersLoadingSelector);

  const [emails, setEmails] = useState<string[]>([]);

  const [phoneNos, setPhoneNos] = useState<string[]>([]);

  const handlePhoneNumbersChange = (nos: string[]) => {
    setPhoneNos(nos);
  };

  const handleGetTokenDisplayLabel = (tokenValue: any, tokenMeta: any) => {
    // Could return any react node
    return <div className="rounded-full">{`${tokenValue}`}</div>;
  };

  const handleTokenValueValidate = (e: string) => {
    const number = /^-?\d+$/;
    if (e.startsWith("+")) {
      if (number.test(e.slice(1))) {
        if (e.length > 9 && e.length < 15) {
          return null;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  const [selectedTab, setSelectedTab] = useState(0);
  const tabs = ["Email", "Phone"];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const [adminInvite, setAdminInvite] = useState(false);
  const [skipAlert, setSkipAlert] = useState(false);

  const handleAdminInvite = () => {
    setAdminInvite((prevState) => !prevState);
  };

  const isMember = useAppSelector(isMemberViewSelector);

  const handleSkipAlert = () => {
    setSkipAlert((prevState) => !prevState);
  };
  const isInvited = useAppSelector(inviteSentSelector);

  useEffect(() => {
    if (isInvited) {
      navigate(`/channels/${channelUuid}/members`);
      dispatch(
        getChannelList({
          hiveId: hiveDetails?.communityId!,
          isMemberView: isMember,
        })
      );
      dispatch(setInvitedMember(false));
    }
  }, [isInvited]);

  useEffect(() => {
    channelUuid && dispatch(setSingleInviteToChannel(channelUuid));
  }, [channelUuid, dispatch]);

  const handleSendInvite = () => {
    const emailUsers: {
      email: string;
    }[] = [];

    const phoneUsers: {
      mobileNo: string;
    }[] = [];

    emails.map((item) => {
      emailUsers.push({ email: item });
    });

    phoneNos.map((item) => {
      phoneUsers.push({ mobileNo: item });
    });

    const phoneData = {
      users: phoneUsers,
      channels: inviteToChannels,
      communityId: hiveDetails?.communityId!,
      skipEmails: skipAlert,
    };
    const emailData = {
      users: emailUsers,
      channels: inviteToChannels,
      communityId: hiveDetails?.communityId!,
      skipEmails: skipAlert,
    };

    if (selectedTab === 0) {
      if (adminInvite) {
        dispatch(emailAdminInvite(emailData));
      } else {
        dispatch(emailMemberInvite(emailData));
      }
    } else {
      if (adminInvite) {
        dispatch(phoneAdminInvite(phoneData));
      } else {
        dispatch(phoneMemberInvite(phoneData));
      }
    }
  };

  return (
    <PageLayout sideMenu={true}>
      <IslandLayout>
        <div className="add_contact_container">
          <BackButton to={`/channels/${channelUuid}/members`} />
          <LineBreak />
          <h3>Invite Members</h3>
          <ContactInput
            tabs={tabs}
            handleChange={handleChange}
            emails={emails}
            setEmails={setEmails}
            phoneNos={phoneNos}
            setPhoneNos={handlePhoneNumbersChange}
            selectedTab={selectedTab}
          />{" "}
          <div className="members_invite_toggles">
            <div className="member_setting_container">
              <Switch checked={adminInvite} onChange={handleAdminInvite} />
              <p>Invite as admin - Default access to all public channels.</p>
            </div>
            <div className="member_setting_container">
              <Switch checked={!skipAlert} onChange={handleSkipAlert} />
              <p>
                Send notifications - Send invite notification as email or sms.
              </p>
            </div>
          </div>
          {emails.length > 0 || phoneNos.length > 0 ? (
            <div onClick={handleSendInvite} className="nextBtn primaryBtn">
              Send Invites
            </div>
          ) : (
            <div className="nextBtn disabledBtn">Send Invites</div>
          )}
          {isLoading && <Loader />}
        </div>
      </IslandLayout>
    </PageLayout>
  );
};

export default ChannelInvite;
